var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v(_vm._s(_vm.$t(_vm.item.label)))]),(!_vm.loading)?_c('td',[_c('span',[_vm._v(_vm._s(_vm.item.translate ? _vm.$t(_vm.value) : _vm.value))])]):_c('td',[_c('e-progress-linear')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }